/**
 * Do not edit directly, this file was auto-generated.
 */

export const MotionDurationInstant = '0ms'; // No transition — use when motion would distract.
export const MotionDurationFast = '100ms'; // Micro-interactions (ripples, focus rings).
export const MotionDurationBase = '150ms'; // DEFAULT — hover/active state changes, color shifts, icon rotations.
export const MotionDurationSlow = '250ms'; // Layout shifts, panel reveals, accordion expand.
export const MotionDurationSlower = '400ms'; // Page-level transitions, full modal enter/exit.
export const MotionDurationLoop = '1000ms'; // One full revolution of an infinite-loop animation (spinners, pulse). 1s feels alive without being frantic.
export const MotionEasingLinear = 'cubic-bezier(0, 0, 1, 1)'; // No easing — for rotations and continuous motion only.
export const MotionEasingStandard = 'cubic-bezier(0.4, 0, 0.2, 1)'; // DEFAULT — most state changes, hover, color.
export const MotionEasingDecelerate = 'cubic-bezier(0, 0, 0.2, 1)'; // Enters — element appearing on screen.
export const MotionEasingAccelerate = 'cubic-bezier(0.4, 0, 1, 1)'; // Exits — element leaving screen.
export const MotionEasingEmphasized = 'cubic-bezier(0.2, 0, 0, 1)'; // Emphasized moves — large, slow, deliberate.
